import { useSelector } from '../../_shared/utils/hooks/useSelector';
import { type AppState } from '../app.store';

const presentationalColumnsRestrictionsStateSelector = (state: AppState) => state.spreadsheet.presentationalColumnsRestrictions;
export const usePresentationalColumnsRestrictionsStateSelector = () => useSelector(presentationalColumnsRestrictionsStateSelector);

const presentationalColumnsRestrictionsIsLoadingSelector = (state: AppState) => state.spreadsheet.presentationalColumnsRestrictions.isLoading;
export const usePresentationalColumnsRestrictionsIsLoadingSelector = () => useSelector(presentationalColumnsRestrictionsIsLoadingSelector);
